import DishesDataTable from "../../../../components/dataTable/tables/canteen/DishesDataTable";

function DishesPageView() {
  return <DishesDataTable />;
}

export default DishesPageView;
